<template>
  <div class="popup-main" ref="popupMain" >
    <div class="close-btn" @click="close()">X</div>
    <div class="popup-content">
      <div class="header">{{ date }}</div>
      <div class="header">{{ timeRange }}</div>
      <div class="grids" ref="grid">
        <div class="timeline">
          <div class="time" v-for="i in times" :key="i" ref="time">{{ timeRange.split(':')[0] }}:{{ i }}</div>
        </div>
        <div v-for="i in 6" :key="i" class="line" ref="lines"></div>
      </div>

      <div class="details" ref="details" @scroll="scrolling">
        <div class="task" v-for="i in items" :key="i" ref="task">
          <div class="progress" ref="progress"></div>
          <span class="status left">{{ i.leftText }}</span>
          <span class="status right">{{ i.rightText }}</span>
          <div style="z-index: 5">
            {{ i.start_date }} {{ i.duration }} {{ i.progress }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {
  },
  props: {
    mainClass: { type: String, default: 'popup-main' },
    items: { type: Array, default: [] },
    times: { type: Array, default: [ '00', '10', '20', '30', '40', '50' ] },
    date: { type: String, default: '' },
    timeRange: { type: String, default: '' },
    width: { type: Number, default: 0 }
  },
  methods: {
    show: function(items, start, end) {
      this.width = window.innerWidth * 0.8 - 100;
      this.$refs.popupMain.style.zIndex = 200;
      this.$refs.popupMain.style.opacity = 1;
      
      this.items = items;
      this.date = this.$dateTime.getDateTime(start, 'dd/MM/yyyy');
      this.timeRange = `${this.$dateTime.getDateTime(start, 'HH:mm')} - ${this.$dateTime.getDateTime(end, 'HH:mm')}`;

      setTimeout(() => {
        var lines = this.$refs.lines;
        var time = this.$refs.time;
        var tasks = this.$refs.task;
        var progress = this.$refs.progress;

        var startingPos = 150;
        var diff = (this.width - 300) / 6;
        var pxPerMin = diff / 10;
        
        lines[0].style.borderWidth = '1px';

        for (var i = 0; i < lines.length; i++) {
          lines[i].style.left = startingPos + 'px';
          lines[i].style.width = diff + 'px';
          startingPos += diff;
        }

        time.forEach((t) => {
          t.style.width = diff + 'px';
        });

        for (var i = 0; i < this.items.length; i++) {
          var startDate = this.$dateTime.stringToDate(this.items[i].start_date, '-');
          var min = this.$dateTime.getDateTime(startDate, 'mm');

          var width = (this.items[i].duration * 60 * pxPerMin);

          tasks[i].style.width =  width + 'px';
          tasks[i].style.left = (150 + (min * pxPerMin)) + 'px';
          tasks[i].style.backgroundColor = this.items[i].color;

          progress[i].style.width = (width * this.items[i].progress) + 'px';
          progress[i].style.backgroundColor = this.items[i].progressColor;
        }
      }, 50);
    },
    close: function() {
      this.$refs.popupMain.style.opacity = 0;

      setTimeout(() => {
        this.$refs.popupMain.style.zIndex = -200;
      }, 300);
    },
    scrolling: function(e) {
      var left = this.$refs.details.scrollLeft;
      this.$refs.grid.style.transform = `translateX(${left * -1}px)`;
    }
  },
  mounted() {
    this.$refs.details.scroll(this.scrolling);
  }
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.popup-main {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  background-color: rgba(0,0,0,0.5);
  top: 0;
  left: 0;
  z-index: -200;
  opacity: 0;
  transition: $transition-time;
}

.header {
  // background-color: yellow;
  height: 20px;
  width: 100%;
  text-align: center;
  font-weight: bold;
}

.popup-content {
  background-color: white;
  height: 80%;
  width: 80%;
  overflow: hidden;
  padding: 10px;
}

.sub-content {
  margin: 10px 0;
  // background-color: yellow;
}

.content {
  overflow: scroll;
  height: 100%;
  padding: 5px;
}

.grids {
  position: relative;
  height: calc(100% - 40px);
  width: 100%;
  // background-color: yellowgreen;
  orientation: landscape;
}

.grids .line {
  border-style: solid;
  border-color: rgba(0,0,0,0.2);
  border-width: 1px 1px 1px 0px;
  position: absolute;
  height: 100%;
  width: 116.667px;
}

.grids .timeline {
  display: flex;
  position: absolute;
  height: 30px;
  width: calc(100% - 300px);
  border-style: solid;
  border-color: rgba(0,0,0,0.2);
  border-width: 0px 0px 1px 0px;
  left: 150px;
}

.time {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8em;
}

.details {
  bottom: calc(100% - 70px);
  position: relative;
  // background-color: rgba(0,0,0,0.2);
  height: calc(100% - 70px);
  width: 100%;
  z-index: 5;
  overflow: scroll;
}

.details .task {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  width: 100px;
  // background-color: yellowgreen;
  margin: 10px 0;
  font-size: 0.8em;
}

.task .status {
  display: flex;
  position: absolute;
  align-items: center;
  height: 100%;
  width: 150px;
  max-width: 200px;
  // background-color: yellowgreen;
  margin: 0 4px;
}

.task .progress {
  position: absolute;
  background-color: black;
  height: 100%;
  // z-index: 20;
  left: 0;
}

.left {
  right: 100%;
  justify-content: flex-end;
  text-align: end;
}

.right {
  left: 100%;
}

.close-btn {
  display: flex;
  position: absolute;
  align-items: center;
  justify-content: center;
  top: 0;
  right: 0;
  height: 30px;
  width: 30px;
  margin: 10px;
  background-color: white;
  padding: 10px;
  border-radius: 100%;
}

.close-btn:hover {
  cursor: pointer;
}
</style>